// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__1UzXs","container":"Footer_container__st7Zp","footerSignature":"Footer_footerSignature__3KHrj","slidein":"Footer_slidein__1VljP"};